import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { ActionSheet, Button,  } from 'antd-mobile/lib';
import { goHome } from '../common';
let wrapProps;
class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: 'none',
    };
  }
  componentWillMount(){
    document.title = this.props.location.state.title
  }
  next(name){
    if (name==='查看我的智投'||name==='返回智投首页') {
      goHome()
    }else if(name==='返回华夏智投'){
      goHome()
    }else if(name==='联系客服'){
      this.showActionSheet()
    }else if(name==='完成'){
      hashHistory.replace({
         pathname:`/SubscriptionDetail?enterType=SubscriptionDetail` ,
      })
      // hashHistory.push({
      //   pathname: '/nullView',
      // });
    }
  }
  showActionSheet = () => {
    const BUTTONS = [<a style={{color:'#111111'}} href="tel:4008175666">呼叫400-817-5666</a> , '取消'];
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      destructiveButtonIndex: BUTTONS.length - 2,
      // title: '标题',
      message: '周一至周五08：30-17：00',
      maskClosable: true,
      'data-seed': 'logId',
      wrapProps,
    },
    (buttonIndex) => {
      this.setState({ clicked: BUTTONS[buttonIndex] });
    });
  }
  render(){
    let _this=this;
    return (
        <div className="container" >

        <NavigatorMain>
          <div className="header black">
            <div ></div>
            <div>{this.props.location.state.title}</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div className='content' >
          <div className='success-box'>
            <img src={require('../img/errorO.png')} style={{width:'1.24rem',height:'1.24rem'}}/>
            <p style={{marginTop:'0.2rem'}}>{this.props.location.state.content}</p>
            <p style={{marginTop:'0.2rem',fontSize:13,color:'#5b6370',lineHeihgt:18}}>{this.props.location.state.content2}</p>
            <div style={{width:'100%',marginTop:30}}>
              {
                this.props.location.state.dataSouse.map(function (item,i) {
                  return(
                    <div key={'cq'+i} className='success-bar'>
                      <p >{item[0]}</p>
                      <p >{item[1]}</p>
                    </div>
                  )
                })
              }
            </div>
          </div>
          {
              this.props.location.state.souseVal.map( (item,i) =>{
                if (i==0) {
                  return(
                    <div key={'bt'+i} onClick={()=>this.next(item)}  className='btn'>
                      {item}
                    </div>
                  )
                }else{
                  return(
                    <div key={'bt'+i} onClick={()=>this.next(item)}  className='btn btn-white'>
                      {item}
                    </div>
                  )
                }
              })
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    
  }
}
export default connect(mapStateToProps)(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/Error.js